"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var R = _interopRequireWildcard(require("ramda"));
var P = _interopRequireWildcard(require("@surge-global-engineering/rpdf-primitives"));
var _resolveDimensions = require("./resolveDimensions");
var _resolveInheritance = _interopRequireDefault(require("./resolveInheritance"));
var _resolveTextLayout = _interopRequireDefault(require("./resolveTextLayout"));
var _resolveStyles = _interopRequireDefault(require("./resolveStyles"));
var _resolvePageSizes = _interopRequireDefault(require("./resolvePageSizes"));
var _resolvePagePaddings = _interopRequireDefault(require("./resolvePagePaddings"));
var _asyncCompose = _interopRequireDefault(require("../utils/asyncCompose"));
var _resolvePagination = _interopRequireDefault(require("./resolvePagination"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-await-in-loop */
/* eslint-disable prefer-destructuring */

/**
 * Time taken to tune `letterSpacing` is inversely proportional to the sensitivity of `letterSpacing`.
 * Increasing the following value will result in a more sensitive `letterSpacing`, at the cost of time.
 */
var BINARY_SEARCH_DEPTH = 8;

/**
 * Max value allowed for letter spacing (coincides with `tracking` in design)
 */
var MAX_RELATIVE_LETTER_SPACING_VALUE = 256;
var isText = R.propEq('type', P.Text);
var isAllowDynamicLetterSpacing = function isAllowDynamicLetterSpacing(node) {
  var _node$style;
  return !!((_node$style = node.style) !== null && _node$style !== void 0 && _node$style.dynamicLetterSpacing);
};
var isOrphanWidowProtectionArtefact = function isOrphanWidowProtectionArtefact(node) {
  var _node$props;
  return !!((_node$props = node.props) !== null && _node$props !== void 0 && _node$props.lineSkips);
};
var assingChildren = R.assoc('children');

/**
 * Relayouts a given page, (with new letterSpacing applied to text nodes)
 * @returns Tuple where first element contains # of pages after re-layouting, second element contains the re-layouted page
 */
var relayoutPage = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(page, pageIndex, doc, fontStore) {
    var _doc$props;
    var isolatedDoc, result;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          isolatedDoc = (0, _extends2.default)({}, doc, {
            props: (0, _extends2.default)({}, doc.props, {
              pageNumberOffset: (((_doc$props = doc.props) === null || _doc$props === void 0 ? void 0 : _doc$props.pageNumberOffset) || 0) + pageIndex
            }),
            children: [page]
          });
          _context.next = 3;
          return (0, _asyncCompose.default)(_resolvePagination.default, _resolveTextLayout.default, _resolveDimensions.resolvePageDimensions, _resolveInheritance.default, _resolvePagePaddings.default, _resolveStyles.default, _resolvePageSizes.default)(isolatedDoc, fontStore);
        case 3:
          result = _context.sent;
          return _context.abrupt("return", [result.children.length, result.children[0]]);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function relayoutPage(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
var applyLetterSpacingProp = function applyLetterSpacingProp(node, letterSpacing) {
  if (isText(node)) {
    if (isOrphanWidowProtectionArtefact(node)) {
      return node;
    }
    if (isAllowDynamicLetterSpacing(node)) {
      var _node$style2;
      /** The absolute value is computed by following _https://helpx.adobe.com/indesign/using/kerning-tracking.html_ */
      var absoluteSpacing = letterSpacing * (1 / 1000) * (((_node$style2 = node.style) === null || _node$style2 === void 0 ? void 0 : _node$style2.fontSize) || 1);
      return R.compose(R.assocPath(['style', 'letterSpacing'], absoluteSpacing))(node);
    }
  }
  if (node.children) {
    return R.compose(R.evolve({
      children: R.map(function (child) {
        return applyLetterSpacingProp(child, letterSpacing);
      })
    }))(node);
  }
  return node;
};
var dropLayoutAttributes = function dropLayoutAttributes(node) {
  // avoid dropping the layout attributes if the node is an artefact. The text content has been split into
  // 2 pages, so we don't want to re-layout the paragraph
  if (isOrphanWidowProtectionArtefact(node)) {
    return node;
  }
  if (isText(node)) {
    return R.compose(R.assocPath(['box'], {}), R.dissocPath(['box']), R.dissocPath(['lines']),
    // drop dynamic renders, as we have already rendeerd them into the page
    // (we still don't drop footnotes because top value is calculated dynamically)
    R.dissocPath(['props', 'render']))(node);
  }
  return R.compose(R.assocPath(['box'], {}), R.dissocPath(['box']),
  // drop dynamic renders, as we have already rendered them into the page
  // (we still don't drop footnotes because top value is calculated dynamically)
  R.dissocPath(['props', 'render']), R.evolve({
    children: R.map(dropLayoutAttributes)
  }))(node);
};
var relayoutPageToIncreaseLines = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(pageIndex, doc, fontStore) {
    var maxCandidateValue, maxBinarySearchDepth, minimumOffsetValue, memoizedResults, page, queryIsPossibleToLayouteInSinglePage, relativeLetterSpace, offset, result;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          /** maximum relative letter space value */
          maxCandidateValue = MAX_RELATIVE_LETTER_SPACING_VALUE;
          /** maximum depth we expect for the binary search. The binary search will cost ~O(maxCandidateValue) */
          maxBinarySearchDepth = BINARY_SEARCH_DEPTH;
          /** minimum offset used within the binary search, determined based on `maxCandidateValue` and `maxBinarySearchDepth` */
          minimumOffsetValue = maxCandidateValue / Math.pow(2, maxBinarySearchDepth);
          /** data structure to memoize already computed relayouting results */
          memoizedResults = new Map();
          page = doc.children[pageIndex];
          /**
           * Relayouts the page and returns true if it is possible to layout the page without overflowing into multiple pages.
           * While doing the relayouting, this function memoizes the results, so no `candidateValue` causes the relayout to happen twice
           */
          queryIsPossibleToLayouteInSinglePage = /*#__PURE__*/function () {
            var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(candidateValue) {
              var preparedPage, result;
              return _regenerator.default.wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    if (!(candidateValue > maxCandidateValue)) {
                      _context2.next = 2;
                      break;
                    }
                    return _context2.abrupt("return", false);
                  case 2:
                    if (!memoizedResults.has(candidateValue)) {
                      _context2.next = 4;
                      break;
                    }
                    return _context2.abrupt("return", memoizedResults.get(candidateValue)[0] === 1);
                  case 4:
                    preparedPage = dropLayoutAttributes(applyLetterSpacingProp(page, candidateValue));
                    _context2.next = 7;
                    return relayoutPage(preparedPage, pageIndex, doc, fontStore);
                  case 7:
                    result = _context2.sent;
                    memoizedResults.set(candidateValue, result);
                    return _context2.abrupt("return", result[0] === 1);
                  case 10:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            return function queryIsPossibleToLayouteInSinglePage(_x8) {
              return _ref3.apply(this, arguments);
            };
          }();
          relativeLetterSpace = -1; // binary search to find the maximum possible letterSpacing while staying under a single page
          offset = maxCandidateValue;
        case 8:
          if (!(offset >= minimumOffsetValue)) {
            _context3.next = 23;
            break;
          }
        case 9:
          if (!true) {
            _context3.next = 20;
            break;
          }
          _context3.next = 12;
          return queryIsPossibleToLayouteInSinglePage(relativeLetterSpace + offset);
        case 12:
          result = _context3.sent;
          if (!result) {
            _context3.next = 17;
            break;
          }
          relativeLetterSpace += offset;
          _context3.next = 18;
          break;
        case 17:
          return _context3.abrupt("break", 20);
        case 18:
          _context3.next = 9;
          break;
        case 20:
          offset /= 2;
          _context3.next = 8;
          break;
        case 23:
          return _context3.abrupt("return", memoizedResults.get(relativeLetterSpace)[1]);
        case 24:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function relayoutPageToIncreaseLines(_x5, _x6, _x7) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Returns the number of lines that have been skipped due to orphan/widow protection
 */
var getLineSkipsCount = function getLineSkipsCount(node) {
  var skipped = 0;
  if (isOrphanWidowProtectionArtefact(node)) {
    skipped += node.props.lineSkips;
  } else if (node.children) {
    for (var index = 0; index < node.children.length; index += 1) {
      skipped += getLineSkipsCount(node.children[index]);
    }
  }
  return skipped;
};

/**
 * Returns `true` if there are text nodes that we can adjust, for page balancing
 */
var hasAdjustableTextNodes = function hasAdjustableTextNodes(node) {
  if (isOrphanWidowProtectionArtefact(node)) {
    return false;
  }
  if (isAllowDynamicLetterSpacing(node)) {
    return true;
  }
  if (node.children) {
    for (var index = 0; index < node.children.length; index += 1) {
      if (hasAdjustableTextNodes(node.children[index])) {
        return true;
      }
    }
  }
  return false;
};

/**
 * Performs page balancing for the paginatd pages.
 *
 * @param {Object} node
 * @param {Object} fontStore font store
 */
var resolvePageBalancing = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(doc, fontStore) {
    var pages, pageIndex, page, linesSkipped, isAdjustable, relayoutedPage;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          pages = [];
          pageIndex = 0;
        case 2:
          if (!(pageIndex < doc.children.length)) {
            _context4.next = 17;
            break;
          }
          page = doc.children[pageIndex];
          linesSkipped = getLineSkipsCount(page);
          isAdjustable = hasAdjustableTextNodes(page);
          if (!(linesSkipped && isAdjustable)) {
            _context4.next = 13;
            break;
          }
          _context4.next = 9;
          return relayoutPageToIncreaseLines(pageIndex, doc, fontStore);
        case 9:
          relayoutedPage = _context4.sent;
          pages.push(relayoutedPage);
          _context4.next = 14;
          break;
        case 13:
          pages.push(page);
        case 14:
          pageIndex += 1;
          _context4.next = 2;
          break;
        case 17:
          return _context4.abrupt("return", assingChildren(pages, doc));
        case 18:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function resolvePageBalancing(_x9, _x10) {
    return _ref4.apply(this, arguments);
  };
}();
var _default = exports.default = resolvePageBalancing;